import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../../decorator/meta-title';
import {NgClass} from '@angular/common';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Site} from '../../../../../../models/site/site';
import {LoaderService} from '../../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {AuthService} from '../../../../../../services/auth/auth.service';
import {SiteService} from '../../../../../../services/site/site.service';
import {WidgetService} from '../../../../../../services/cms/widget.service';
import {forkJoin} from 'rxjs';
import {WidgetTypes} from '../../../../../../constants/widget-type';
import {WidgetList} from '../../../../../../models/cms/widget/widget-list';
import {Scope} from '../../../../../../constants/scope';
import {
  ProductPrioritySelectorComponent
} from '../../../../../layout/product-priority-selector/product-priority-selector.component';

@Component({
  selector: 'app-widget-add',
  imports: [
    NgClass,
    RouterLink,
    ReactiveFormsModule,
    ProductPrioritySelectorComponent
  ],
  templateUrl: './widget-add.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-add.component.scss'
})
@IsGranted(['WIDGET_VIEW'])
@MetaTitle('Widget Add')
export class WidgetAddComponent implements OnInit {
  sites: Site[] = [];
  widgetList: WidgetList[] = [];
  loaded = false;

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    siteId: new FormControl<number | null>(null, Validators.required),
    type: new FormControl('', Validators.required),
    scope: new FormControl(Scope.PUBLIC, Validators.required),
    productPriority: new FormControl<string | null>(null),
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private siteService: SiteService,
    private widgetService: WidgetService,
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();

    forkJoin([
      this.siteService.findAll({sort: 'name'}),
      this.widgetService.getWidgetList()
    ]).subscribe(([sites, widgetList]) => {
      this.sites = sites;
      this.widgetList = widgetList.filter(item => WidgetTypes.find(type => type.identifier === item.identifier)).map(item => new WidgetList().deserialize(item));

      this.loader.stopLoading();
      this.loaded = true;
    });
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    let params: any = this.form.value;

    this.loader.startLoading();

    this.widgetService.create(params).subscribe((result: any) => {
      this.loader.stopLoading();
      this.snackbar.success('Widget has been created.');
      this.router.navigateByUrl('/promotion-tools/cms/widgets/' + result.id).then();
    });
  }
}
